<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title39"></a>
<div class="p-c"><span>This book is dedicated to</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span><strong class="b">NATHAN CROW</strong></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c-br"><span>And all the young men and women of: <br/>The Virginia Military Institute <br/>West Point <br/>Annapolis <br/>The Air Force Academy <br/>The Coast Guard Academy <br/>Norwich <br/>The Citadel <br/>and <br/>Texas A&amp;M. <br/>These youths, past and present, have freely chosen <br/>to endure personal sacrifice and hardship by <br/>dedicating their lives to defend and uphold the <br/>ideals and principles that have made this nation and <br/>its people unlike any other.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466824904_ded01.vue?1745dcd5